import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, deviceDetailFeatureKey } from './device-detail.reducer';

export const deviceDetailFeature = createFeatureSelector<State>(deviceDetailFeatureKey);

export const getDevice = createSelector(deviceDetailFeature, (state) => {
   return state.device;
});

export const getDeviceCallState = createSelector(deviceDetailFeature, (state) => {
   return state.callState;
});
